export class ScanPriority {
  id: number;
  name: string;
  priority: number;
  created_by: any;
  updated_by: any;
  intranet_id: number;
  created_at: any;
  updated_at: any;
  saving: boolean = false;
  deleting: boolean = false;
  priorityChanged: boolean = false;
  changed: boolean = false;
}
